<div
  class="main-content"
  [ngClass]="alayticsService.currentTheme === 'material-dark' ? 'dark-theme' : ''"
>
  <ngx-spinner
    template="<img src='/assets/icons/Respond-spinner.gif' height='170' width='170' class='text-center' loading='lazy'/>"
    [showSpinner]="loading"
    *ngIf="router.url.includes('teacher-classroom') && isModal"
    size="small"
    [disableAnimation]="false"
    color="white"
    bdColor="rgba(0,0,0,0.5)"
    [fullScreen]="false"
    [zIndex]="1003"
  >
  </ngx-spinner>

  <div *ngIf="isModal">
    <div class="row" style="margin-top: -1rem">
      <div class="col-md-12 d-flex justify-content-center">
        <nb-card class="cursor-pointer classroom-details">
          <nb-card-body>
            <div class="d-flex justify-content-between">
              <div class="classroom-name-content text-left">
                <h5 class="classroom-name quicksand-bold-label">
                  {{ classroom?.name }}
                </h5>

                <div class="classroom-subject quicksand-bold-label">
                  {{ classroom?.subject | uppercase }}
                </div>
              </div>

              <div class="d-flex" style="margin-right: -5px">
                <div class="classroom-code text-center">
                  {{ classroom?.code }}
                </div>
              </div>
            </div>
          </nb-card-body>
        </nb-card>

        <div class="btn-close-content">
          <button class="btn-close" (click)="closeDialog()">
            <nb-icon icon="collapse" class="icon-close-expand-view"></nb-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-container>
    <div
      class="pagination d-flex justify-content-end quicksand-bold-label mb-3"
      *ngIf="currentPage !== 1 || studentExtraHelp?.length > 0"
    >
      <span class="quicksand-bold-label mt-2"
        >{{ currentPage }} / {{ totalPages }}</span
      >
      <button
        class="btn-paginate mr-2 ml-2 quicksand-bold-label"
        (click)="currentPage = currentPage - 1; getStudentExtraHelpByPage()"
        [disabled]="currentPage === 1"
      >
        <nb-icon icon="arrow-back-outline"></nb-icon>
      </button>

      <button
        class="btn-paginate quicksand-bold-label"
        (click)="currentPage = currentPage + 1; getStudentExtraHelpByPage()"
        [disabled]="currentPage === totalPages"
      >
        <nb-icon icon="arrow-forward-outline"></nb-icon>
      </button>
    </div>
  </ng-container>

  <div
    class="col-md-12 lesson-plan-content p-0"
    *ngIf="studentExtraHelp && studentExtraHelp.length > 0"
  >
    <nb-card
      class="border-none extra-help-card cursor-pointer"
      *ngFor="let extraHelp of studentExtraHelp"
      (click)="openHelpRequestModal(extraHelp)"
    >
      <div class="row m-0 p-0">
        <div
          class="m-0 p-0 request-content {{ isModal ? 'col-md-2 pl-3' : 'col-md-4' }}"
        >
          <div class="requested-by-content pl-2">
            <label
              class="content-label main-content-label quicksand-normal-label"
              >Requested By:</label
            >

            <div class="user-content d-flex">
              <img
                *ngIf="utilService.getProfileImage(extraHelp?.from_user)"
                [src]="'/assets/images/no-profile-image.png'"
               height="43"
                width="43"
               class="request-img mr-2"
                alt="no-img"
              />

              <img
                [src]="extraHelp?.from_user?.user_profile_media?.image?.url"
                alt="profile-img"
                height="43"
                width="43"
               class="request-img mr-2"
                *ngIf="!utilService.getProfileImage(extraHelp?.from_user)"
              />

              <div class="name-content ml-2 d-block">
                <h6 class="quicksand-bold-label user-name">
                  {{ extraHelp?.from_user?.firstName | titlecase }}
                  {{ extraHelp?.from_user?.lastName | titlecase }}
                </h6>
                <label
                  class="content-label quicksand-normal-label time-label-content"
                  >{{
                  extraHelp?.from_time | date: 'MMM d, y, h:mm a'
                  }}</label
                >
              </div>
            </div>
          </div>

          <div class="responded-by-content pl-2">
            <label
              class="content-label main-content-label quicksand-normal-label"
              >Responded By:</label
            >
            <div class="user-content d-flex">
              <img
                [src]="
                  !extraHelp?.respondedByUser?.user_profile_media_id
                    ? '/assets/images/no-profile-image.png'
                    : extraHelp?.respondedByUser?.user_profile_media?.image?.url
                "
                height="40"
                width="40"
                class="profile-img-content"
                alt="no-img"
              />

              <div class="name-content ml-2 d-block">
                <h6 class="quicksand-bold-label user-name">
                  {{ extraHelp?.respondedByUser?.firstName | titlecase }}
                  {{ extraHelp?.respondedByUser?.lastName | titlecase }}
                </h6>
                <label
                  class="content-label quicksand-normal-label time-label-content"
                  >{{
                  extraHelp?.to_time | date: 'MMM d, y, h:mm a'
                  }}</label
                >
              </div>
            </div>
          </div>
        </div>

        <div
          class="m-0 pt-2 pl-3 pr-3 pb-3 {{ isModal ? 'col-md-10' : 'col-md-8' }}"
        >
          <div class="question-content">
            <div class="d-flex">
              <img
                src="/assets/images/question-extra-help.svg"
                alt="question"
                height="25"
                width="25"
              />
              <label class="content-label quicksand-normal-label ml-2"
                >Question</label
              >
            </div>

            <div class="question-label quicksand-bold-label">
              {{ extraHelp?.assignment_questions[0]?.content }}
            </div>
          </div>

          <div class="answer-content mt-4">
            <div class="d-flex">
              <img
                src="/assets/images/answer-extra-help.svg"
                alt="question"
                height="25"
                width="25"
              />
              <label class="content-label quicksand-normal-label ml-2"
                >Answer</label
              >
            </div>

            <div class="answer-label quicksand-bold-label">
              {{ extraHelp?.user_answer }}
            </div>
          </div>
        </div>
      </div>
    </nb-card>
  </div>

  <div
    class="col-md-12 text-center quicksand-bold-label studentExtraHelp-margin"
    *ngIf="studentExtraHelp && studentExtraHelp.length === 0"
  >
    <img
      src="/assets/images/respond-edu.svg"
      alt="responed-edu"
      height="100"
      width="100"
    />
    <br />
    No Requests Found!
  </div>
</div>

<!-- help request modal -->
<!-- <ng-template #myModal let-modal>
  <div
    #myModal
    class="add-classroom-modal lesson-plan-modal"
    [ngClass]="{
      'add-assingment-modal': isModal,
      'dark-theme': analyticsService?.currentTheme === 'material-dark'
    }"
  >
    <div class="modal-header d-flex justify-content-between align-items-center w-100">
      <div class="d-flex">
        <span class="icon-add-classroom">
          <nb-icon icon="plus-outline"></nb-icon>
        </span>
        <h6 class="add-clasroom-text quicksand-bold-label m-0">View Help Request</h6>
      </div>

      <div>
        <span
          class="icon-close-classroom-modal d-block cursor-pointer"
          (click)="modalService.dismissAll(modalRef);"
        >
          <nb-icon icon="close-outline" class="text-dark icon-close"></nb-icon>
        </span>
      </div>
    </div>

    <div [ngClass]="analyticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''" class="modal-body">
      <div class="row mb-3 p-2">
        <div class="col-6">
          <label class="quicksand-bold-label label-form">Requested By:</label>
          <div class="user-request-value d-flex quicksand-bold-label">
            <img
              height="30"
              width="30"
              [src]="
                currentRequest?.from_user?.user_profile_media_id !== 0
                  ? currentRequest?.from_user?.user_profile_media?.image?.url
                  : '/assets/images/no-profile-image.png'
              "
              class="request-img mr-2"
              alt="user-profile"
            />
            <div class="pt-1">
              {{ currentRequest?.from_user?.firstName | titlecase }}
              {{ currentRequest?.from_user?.lastName | titlecase }}
            </div>
          </div>
        </div>

        <div class="col-6">
          <label class="quicksand-bold-label label-form">Responded By:</label>
          <div class="user-request-value d-flex quicksand-bold-label">
            <img
              height="30"
              width="30"
              [src]="
                currentRequest?.responded_by?.user_profile_media_id !== 0
                  ? currentRequest?.responded_by?.user_profile_media?.image?.url
                  : '/assets/images/no-profile-image.png'
              "
              class="request-img mr-2"
              alt="user-profile"
            />
            <div class="pt-1">
              {{ currentRequest?.responded_by?.firstName | titlecase }}
              {{ currentRequest?.responded_by?.lastName | titlecase }}
            </div>
          </div>
        </div>

        <div class="col-6 mt-3">
          <label class="quicksand-bold-label label-form">Classroom</label>
          <div class="quicksand-bold-label">
            {{ currentRequest?.classroom?.name }}
          </div>
        </div>

        <div class="col-6 mt-3">
          <label class="quicksand-bold-label label-form">Message</label>
          <div class="quicksand-bold-label">
            {{ currentRequest?.message }}
          </div>
        </div>
      </div>

      <hr class="mt-4 mb-4" />
      <nb-card *ngIf="currentRequest && currentRequest?.assignment_questions?.length > 0" class="questions-card">
        <nb-card-header class="label form-control-label quicksand-bold-label">Assignment Question</nb-card-header>
        <nb-card-body>
          <div class="form-group mt-0">
            <label class="label form-control-label quicksand-bold-label label-form">Question</label><br />
            <label class="nb-input quicksand-bold-label">{{ currentRequest?.assignment_questions[0]?.content }}</label>
          </div>
          <div class="form-group">
            <label class="label form-control-label quicksand-bold-label label-form">Options</label>
            <div class="d-flex" *ngFor="let option of currentRequest?.assignment_questions[0]?.options; let i = index">
              <img src="/assets/icons/checked_option.svg" style="width: 25px; height: 25px" alt="checked_option" loading='lazy' >
              <input
                type="text quicksand-bold-label"
                class="nb-input quicksand-bold-label no-border-content ml-3 p-0 {{ i > 0 ? 'mt-3' : '' }}"
                nbInput
                fullWidth
                readonly="true"
                placeholder="Option"
                value="{{ option }}"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="label form-control-label quicksand-bold-label label-form">Answer</label>
            <br />
            <textarea
              nbInput
              placeholder="Answer"
              class="w-100 no-border-content quicksand-bold-label p-0"
              mat-autosize="true"
              readonly
              value="{{ currentRequest?.assignment_questions[0]?.answer }}"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              ngxTextareaAutoresize
            ></textarea>
          </div>
        </nb-card-body>
      </nb-card>

      <div class="form-group">
        <label class="label form-control-label quicksand-bold-label response"> Response </label>

        <textarea
          class="form-control message-input users-input text-area quicksand-bold-label"
          nbInput
          id="comment"
          mat-autosize="true"
          readonly
          [value]="currentRequest?.status === 1 ? currentRequest?.user_answer : 'No Response Yet'"
          [ngClass]="{
            'px-0': analyticsService?.currentTheme === 'material-dark'
          }"
        >
        </textarea>
      </div>
    </div>
    <div class="d-none"></div>
  </div>
</ng-template> -->

<div
  class="overlay-modal-content modal fade"
  #helpRequestModal
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div
      class="modal-content add-classroom-modal lesson-plan-modal"
      [ngClass]="{
        'add-assingment-modal': isModal,
        'dark-theme': alayticsService?.currentTheme === 'material-dark',
      }"
    >
      <div
        class="modal-header d-flex justify-content-between align-items-center w-100"
      >
        <div class="d-flex align-items-center">
          <span class="icon-add-classroom">
            <nb-icon icon="plus-outline"></nb-icon>
          </span>
          <h6 class="add-clasroom-text quicksand-bold-label m-0">
            View Help Request
          </h6>
        </div>

        <div>
          <span
            class="icon-close-classroom-modal d-block cursor-pointer"
            (click)="closeModal()"
          >
            <nb-icon
              icon="close-outline"
              class="text-dark icon-close"
            ></nb-icon>
          </span>
        </div>
      </div>

      <div
        class="modal-body"
        [ngClass]="alayticsService?.currentTheme === 'material-dark' ? 'dark-theme' : ''"
      >
        <div class="row mb-3 p-2">
          <div class="col-6">
            <label class="quicksand-bold-label label-form">Requested By:</label>
            <div class="user-request-value d-flex quicksand-bold-label">
             <img
                *ngIf="utilService.getProfileImage(currentRequest?.from_user)"
                [src]="'/assets/images/no-profile-image.png'"
                height="43"
                width="43"
               class="request-img mr-2"
                alt="no-img"
              />

              <img
                [src]="currentRequest?.from_user?.user_profile_media?.image?.url"
                 alt="user-profile"
                height="43"
                width="43"
                class="request-img mr-2"
                *ngIf="!utilService.getProfileImage(currentRequest?.from_user)"
              />

              <div class="pt-1">
                {{ currentRequest?.from_user?.firstName | titlecase }}
                {{ currentRequest?.from_user?.lastName | titlecase }}
              </div>
            </div>
          </div>

          <div class="col-6">
            <label class="quicksand-bold-label label-form">Responded By:</label>
            <div class="user-request-value d-flex quicksand-bold-label">
         
              <img
                src="/assets/images/no-profile-image.png"
                alt="user-profile"
                height="43"
                width="43"
                 class="request-img mr-2"
                *ngIf="utilService.getProfileImage(currentRequest?.respondedByUser)"
              />
              <img
                [src]="currentRequest?.respondedByUser?.user_profile_media?.image?.url"
                alt="profile-img"
                height="43"
                width="43"
                 class="request-img mr-2"
                *ngIf="!utilService.getProfileImage(currentRequest?.respondedByUser)"
              />
              <div class="pt-1">
                {{ currentRequest?.respondedByUser?.firstName | titlecase }}
                {{ currentRequest?.respondedByUser?.lastName | titlecase }}
              </div>
            </div>
          </div>

          <div class="col-6 mt-3">
            <label class="quicksand-bold-label label-form">Classroom</label>
            <div class="quicksand-bold-label">
              {{ currentRequest?.classroom?.name }}
            </div>
          </div>

          <div class="col-6 mt-3">
            <label class="quicksand-bold-label label-form">Message</label>
            <div class="quicksand-bold-label">
              {{ currentRequest?.message }}
            </div>
          </div>
        </div>

        <hr class="mt-4 mb-4" />
        <nb-card
          *ngIf="currentRequest && currentRequest?.assignment_questions?.length > 0"
          class="questions-card"
        >
          <nb-card-header class="label form-control-label quicksand-bold-label"
            >Assignment Question</nb-card-header
          >
          <nb-card-body>
            <div class="form-group mt-0">
              <label
                class="label form-control-label quicksand-bold-label label-form"
                >Question</label
              ><br />
              <label
                class="nb-input quicksand-bold-label"
                >{{ currentRequest?.assignment_questions[0]?.content }}</label
              >
            </div>
            <div class="form-group">
              <label
                class="label form-control-label quicksand-bold-label label-form"
                >Options</label
              >
              <div
                class="d-flex"
                *ngFor="let option of currentRequest?.assignment_questions[0]?.options; let i = index"
              >
                <img
                  src="/assets/icons/checked_option.svg"
                  style="width: 25px; height: 25px"
                  alt="checked_option"
                />
                <input
                  type="text quicksand-bold-label"
                  class="nb-input quicksand-bold-label no-border-content ml-3 p-0 {{ i > 0 ? 'mt-3' : '' }}"
                  nbInput
                  fullWidth
                  readonly="true"
                  placeholder="Option"
                  value="{{ option }}"
                />
              </div>
            </div>

            <div class="form-group">
              <label
                class="label form-control-label quicksand-bold-label label-form"
                >Answer</label
              >
              <br />
              <textarea
                nbInput
                placeholder="Answer"
                class="w-100 no-border-content quicksand-bold-label p-0"
                mat-autosize="true"
                readonly
                value="{{ currentRequest?.assignment_questions[0]?.answer }}"
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                ngxTextareaAutoresize
              ></textarea>
            </div>
          </nb-card-body>
        </nb-card>

        <div class="form-group">
          <label class="label form-control-label quicksand-bold-label response">
            Response
          </label>

          <textarea
            class="form-control message-input users-input text-area quicksand-bold-label"
            nbInput
            id="comment"
            mat-autosize="true"
            readonly
            [value]="currentRequest?.status === 1 ? currentRequest?.user_answer : 'No Response Yet'"
            [ngClass]="{
              'px-0': alayticsService?.currentTheme === 'material-dark',
            }"
          >
          </textarea>
        </div>
      </div>
      <div class="d-none"></div>
    </div>
  </div>
</div>
